import { useRouter } from "next/router";

import messages, { MessageType, TransMsg } from "../i18n/messages";

function getMessage(msg: TransMsg, locale: string): string {
  return msg[locale.replaceAll("-", "")];
}

export interface Translation {
  msg: MessageType;
  // eslint-disable-next-line no-unused-vars
  t: (msg: TransMsg) => string;
}

export function useTranslation(): Translation {
  const { locale } = useRouter();

  const t = (msg: TransMsg) => {
    //  @ts-ignore
    return getMessage(msg, locale);
  };

  return { msg: messages, t };
}
